export default __webpack_public_path__ + "static/media/F8.e92031cf.gif";